<template>
  <div>
    <v-menu
      offset-y
      left
      transition="slide-y-transition"
      rounded="xl"
      :nudge-bottom="12"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          class="account-trigger-btn px-2 pl-3"
          text
          rounded
          height="38"
        >
          <span class="admin-label mr-2 hidden-sm-and-down">Admin</span>
          <v-avatar size="28" class="account-avatar">
            <v-icon color="#2e9e60" size="28">mdi-account-circle</v-icon>
          </v-avatar>
          <v-icon size="16" color="#94a3b8" class="ml-1">mdi-chevron-down</v-icon>
        </v-btn>
      </template>

      <v-card class="account-card" elevation="10" rounded="xl" width="280px">
        <v-list class="py-0">
          <v-list-item class="px-4 py-3">
            <v-list-item-avatar color="#e8f7ee" size="40">
              <v-icon color="#2e9e60" size="24">mdi-shield-account-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="user-welcome">Welcome back!</v-list-item-title>
              <v-list-item-subtitle v-if="appLogin" class="user-email">{{ appUser }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider class="mb-2"></v-divider>
          


        <div class="px-4 pb-4 pt-2">
          <v-btn
            v-if="!appLogin"
            color="#2e9e60"
            dark
            depressed
            block
            rounded
            height="40"
            to="/login"
            class="action-btn-dropdown"
          >
            Sign In
          </v-btn>
          <v-btn
            v-if="appLogin"
            color="#e1f0e8"
            depressed
            block
            rounded
            height="40"
            @click="appLogout"
            class="logout-btn-dropdown"
          >
            Logout
          </v-btn>
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import store from "../../store";

export default {
  data() {
    return {
      user: {},
    };
  },
  computed: {
    appLogin() {
      return store.state.isLoggedIn;
    },
    appUser() {
      return store.state.email;
    },
  },
  methods: {
    appLogout() {
      store.commit("logoutUser", true);
    },
  },
};
</script>

<style scoped>
.account-trigger-btn {
  background-color: #ffffff !important;
  border: 1px solid #a8e2c3 !important;
  text-transform: none !important;
  letter-spacing: 0px;
  display: flex;
  align-items: center;
  transition: all 0.2s ease !important;
  padding: 0 8px !important;
}

.account-trigger-btn:hover {
  background-color: #e8f7ee !important;
  border-color: #2e9e60 !important;
}

.admin-label {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 12px;
  color: #334155;
}

.account-avatar {
  background-color: transparent;
}

.account-card {
  border: 1px solid #f1f5f9;
  overflow: hidden;
}

.user-welcome {
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #1e293b;
}

.user-email {
  font-family: 'Poppins', sans-serif;
  font-size: 11px;
  color: #64748b;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
}

.dropdown-item {
  min-height: 40px !important;
}

.dropdown-item:hover {
  background-color: #f8fafc;
}

.dropdown-text {
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  color: #334155;
  font-weight: 500;
}

.action-btn-dropdown {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 13px;
  text-transform: none;
  letter-spacing: 0.2px;
}

.logout-btn-dropdown {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 13px;
  text-transform: none;
  letter-spacing: 0.2px;
  color: #2e9e60 !important;
  transition: all 0.2s ease;
}

.logout-btn-dropdown:hover {
  background-color: #ffd6d6 !important;
  color: #ff5252 !important;
}
</style>
